import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { formInputStyle, formEntryStyle } from '@css/styles'
import { white, black, cdmUrl, tableGray, borderGray } from '@css/constants'

type Props = {
  arrowVariant: 'blue' | 'lightBlue'
  variant: 'default' | 'simple'
}

export const SelectorContainer = styled('select')<Props>(props => css`
  ${formInputStyle};
  ${formEntryStyle};
  color: ${black};

  padding: ${props.variant === 'simple'
    ? '10px 23px 10px 10px'
    : '12px 10px'
  };

  width: 100%;
  height: ${props.variant === 'simple' ? 39 : 56}px;
  margin: 0 auto;

  text-indent: 0.01px;
  text-overflow: '';

  border-color: ${props.variant === 'simple'
    ? tableGray
    : borderGray
  };
  border-radius: ${props.variant === 'simple' ? 4 : 2}px;

  background-color: ${white};
  background: ${props.variant === 'default'
    ? `${cdmUrl('leadgens/7ec/dropdown-btn.svg')} right center no-repeat ${white}`
    : `none`
  };
  background-size: contain;

  &::-ms-expand {
    display: none;
  }
`)

export const arrowIconStyles = css`
  position: relative;
  left: -18px;
  transform: rotate(-90deg);
  width: 9px;
`
